import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Row, Select, Table } from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import { setLoading } from "../../../../redux/store/common/commonDuck";
import status from "../../../../utils/status";

const BrandCase = ({
  targetYear,
  setTargetYear,
  targetMonth,
  setTargetMonth,
  brandOrderList,
  summary,
}) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [noticeList, setNoticeList] = useState([
    { title: "정산 월", data: "04월" },
    { title: "매출액", data: 0 },
    { title: "수수료", data: 0 },
    { title: "정산금액", data: 0 },
  ]);

  const columns = [
    {
      title: "주문번호",
      dataIndex: "order_id",
      key: "order_id",
      // width: 100,
      align: "center",
    },
    {
      title: "상품주문번호",
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      align: "center",
      // width: 100,
      render: (value) => {
        if (typeof value === "string" && value.includes("-delivery")) {
          return value.replace("-delivery", "");
        } else {
          return value;
        }
      },
    },
    {
      title: "구분",
      dataIndex: "type",
      key: "type",
      align: "center",
      // width: 80,
      render: (value) => {
        return value === 1 ? "상품주문" : "배송비";
        // return "상품주문"
      },
    },
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
      ellipsis: true,
      width: 200,
      render: (value, record) => {
        if (value && record) {
          return value + ` - ${record?.option_title}`;
        }
      },
    },
    {
      title: "구매자명",
      dataIndex: "name",
      key: "name",
      align: "center",
      // width: 100,
      render: (value) => {
        if (value?.length < 3) {
          return value.slice(0, 1) + "*";
        } else {
          return value.slice(0, 1) + "*" + value.charAt(value?.length - 1);
        }
      },
    },
    {
      title: "정산 금액",
      // dataIndex: 'profit_price',
      dataIndex: "",
      // key: 'profit_price',
      key: "",
      align: "center",
      render: (value, record) => {
        if (value) {
          if (record.order_detail_status === "complete") {
            let returnPrice = record.total_price;
            if (record.query) {
              if (record.is_cooperate) {
                returnPrice =
                  returnPrice -
                  Math.round(
                    record.total_price *
                      ((record.cooperate_fee_rate * 1.1) / 100),
                  );
                // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
                if (record.dy_commission_include) {
                  returnPrice =
                    returnPrice - Math.floor(record.total_price * 0.11);
                }
              } else {
                returnPrice =
                  returnPrice -
                  Math.round(
                    record.total_price * ((record.commission_rate * 1.1) / 100),
                  );
                returnPrice =
                  returnPrice - Math.round(record.total_price * 0.11);
              }
            } else {
              returnPrice = returnPrice - Math.round(record.total_price * 0.11);
            }
            //  {
            //     if (record.is_influencer) {
            //         returnPrice = returnPrice - Math.round(record.total_price * ((record.commission_rate * 1.1) / 100))
            //     }
            //     returnPrice = returnPrice - Math.round(record.total_price * 0.11)
            // }
            // if (record.total_price < record.delivery_price_baseline) {
            //     returnPrice = returnPrice - record.delivery_price * 0.11;
            // }
            return <p className={`blue`}>{returnPrice.toLocaleString()}</p>;
          } else {
            return <p className={`blue`}>0</p>;
          }
        }
      },
    },
    {
      title: "판매 금액",
      dataIndex: "total_price",
      key: "total_price",
      align: "center",
      render: (value) => {
        if (value) {
          return <p>{value.toLocaleString()}</p>;
        }
      },
    },
    {
      title: "수수료 합계",
      dataIndex: "",
      key: "",
      align: "center",
      render: (value, record) => {
        if (record.order_detail_status === "complete") {
          let fee_total = 0;
          if (record.query) {
            if (record.is_cooperate) {
              fee_total += Math.round(
                record.total_price * ((record.cooperate_fee_rate * 1.1) / 100),
              );
              // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
              if (record.dy_commission_include) {
                fee_total += Math.floor(record.total_price * 0.11);
              }
            } else {
              fee_total += Math.round(
                record.total_price * ((record.commission_rate * 1.1) / 100),
              );
              fee_total += Math.round(record.total_price * 0.11);
            }
          } else {
            fee_total += Math.round(record.total_price * 0.11);
          }
          // if (record.is_cooperate) {
          //     fee_total += Math.round(record.total_price * ((record.cooperate_fee_rate * 1.1) / 100));
          // } else {
          //     if (record.is_influencer) {
          //         fee_total += Math.round(record.total_price * (record.influencer_fee_rate / 100));
          //     }
          //     fee_total += Math.round(record.total_price * 0.11);
          // }
          // if (record.total_price < record.delivery_price_baseline) {
          //     fee_total += record.delivery_price * 0.11;
          // }
          return <p className={`red`}>-{fee_total?.toLocaleString()}</p>;
        } else {
          return 0;
        }
      },
    },
    {
      title: "당영 관리 수수료",
      dataIndex: "commission_dy",
      key: "commission_dy",
      align: "center",
      render: (value, record) => {
        if (record.order_detail_status === "complete") {
          // 일반 구매
          if (!record.is_cooperate) {
            return "-" + Math.round(record.total_price * 0.11).toLocaleString();
          }
          // 공동구매
          else {
            // 공동구매 시 - 당영 관리 수수료 11%
            if (record.dy_commission_include) {
              return (
                "-" + Math.floor(record.total_price * 0.11).toLocaleString()
              );
            } else {
              return 0;
            }
          }
        } else {
          return 0;
        }
      },
    },
    {
      title: "매출 연동 수수료",
      dataIndex: "commission_sell",
      key: "commission_sell",
      align: "center",
      render: (value, record) => {
        if (record.order_detail_status === "complete") {
          if (record.query) {
            if (record.is_cooperate) {
              return (
                "-" +
                Math.round(
                  record.total_price *
                    ((record.cooperate_fee_rate * 1.1) / 100),
                ).toLocaleString()
              );
            } else {
              return (
                "-" +
                Math.round(
                  record.total_price * ((record.commission_rate * 1.1) / 100),
                ).toLocaleString()
              );
            }
          } else {
            return 0;
          }
          // if (record.is_cooperate) {
          //     return "-" + Math.round(record.total_price * ((record.cooperate_fee_rate * 1.1) / 100)).toLocaleString()
          // } else if (record.is_influencer) {
          //     return "-" + Math.round(record.total_price * (record.influencer_fee_rate / 100)).toLocaleString()
          // } else {
          //     return 0
          // }
        } else {
          return 0;
        }
      },
    },
    // {
    //     title: '배송 관리 수수료',
    //     dataIndex: 'delivery_price',
    //     key: 'delivery_price',
    //     align: "center",
    //     render: (value, record) => {
    //         if (record.order_detail_status === "complete") {
    //             if (record.total_price < record.delivery_price_baseline) {
    //                 return (
    //                     <p>
    //                         -{(value * 0.11).toLocaleString()}
    //                     </p>
    //                 )
    //             } else {
    //                 return (
    //                     <p>0</p>
    //                 )
    //             }
    //         }
    //     }
    // },
    // {
    //     title: '결제일',
    //     dataIndex: 'payment_created_at',
    //     key: 'payment_created_at',
    //     align: "center",
    //     render: (value) => {
    //         if (value) {
    //             return (
    //                 <p>
    //                     {moment(value).format("YYYY.MM.DD HH:mm")}
    //                 </p>
    //             )
    //         }
    //     }
    // },
  ];

  const handleMonth = (value) => {
    let list = [...noticeList];
    list[0].data = moment(value).format("MM") + "월";
    setNoticeList([...list]);
    setTargetMonth(moment(value).format("MM"));
  };

  useEffect(() => {
    let list = [...noticeList];
    list[0].data = targetMonth + "월";
    setNoticeList(list);
  }, [targetMonth]);

  useEffect(() => {
    let list = [...noticeList];
    list[1].data = summary.total_purchase_amount;
    list[2].data = summary.dy_manage_fee + summary.sales_fee;
    // + summary.delivery_manage_fee;
    list[3].data = summary.expected_payment_amount;
    setNoticeList(list);
  }, [summary]);

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    let excelData = brandOrderList.map((row) => {
      // if (row.query) {
      //     if (row.is_cooperate) {
      //         profit_price = profit_price - Math.round(row.total_price * ((row.cooperate_fee_rate * 1.1) / 100))
      //     } else {
      //         // if (row.is_influencer) {
      //         //     profit_price = profit_price - Math.round(row.total_price * (row.influencer_fee_rate / 100))
      //         // }
      //         profit_price = profit_price - Math.round(row.total_price * (row.influencer_fee_rate / 100))
      //         profit_price = profit_price - Math.round(row.total_price * 0.11)
      //     }
      // }
      // if (row.total_price < row.delivery_price_baseline) {
      //     profit_price = profit_price - row.delivery_price * 0.11;
      // }

      // 각 수수료 계산
      let commission_dy = 0;
      let commission_sell = 0;

      // 수수료 합계
      let fee_total = 0;
      if (row.query) {
        if (row.is_cooperate) {
          commission_sell = Math.round(
            row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
          );
          fee_total += Math.round(
            row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
          );
          // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
          if (row.dy_commission_include) {
            commission_dy = Math.round(row.total_price * 0.11);
            fee_total += Math.round(row.total_price * 0.11);
          }
        } else {
          commission_sell = Math.round(
            row.total_price * ((row.commission_rate * 1.1) / 100),
          );
          commission_dy = Math.round(row.total_price * 0.11);
          fee_total +=
            Math.round(row.total_price * ((row.commission_rate * 1.1) / 100)) +
            Math.round(row.total_price * 0.11);
        }
      } else {
        commission_dy = Math.round(row.total_price * 0.11);
        fee_total += Math.round(row.total_price * 0.11);
      }
      // 정산 금액
      let profit_price = row.total_price - fee_total;
      // if (row.total_price < row.delivery_price_baseline) {
      //     fee_total += row.delivery_price * 0.11;
      // }

      // 당영 관리 수수료
      // let commission_dy = row.is_cooperate ? 0 : Math.round(row.total_price * 0.11);
      // 매출 연동 수수료
      // let commission_sell = row.is_cooperate ?
      //     Math.round(row.total_price * ((row.cooperate_fee_rate * 1.1) / 100))
      //     : Math.round(row.total_price * (row.influencer_fee_rate / 100));
      // 배송 관리 수수료
      // let delivery_price = (row.total_price < row.delivery_price_baseline) ? row.delivery_price * 0.11 : 0;
      return {
        order_id: row.order_id,
        order_detail_id:
          typeof row.order_detail_id === "string" &&
          row.order_detail_id.includes("-delivery")
            ? parseInt(row.order_detail_id.replace("-delivery", ""))
            : row.order_detail_id,
        type: row.type === 1 ? "상품주문" : "배송비",
        order_detail_status:
          status.matchingOrderStatus[row.order_detail_status],
        product_id: row.product_id,
        product_name: row.product_name,
        option_id: row.option_id,
        option_title: row.option_title,
        name: row.name,
        profit_price: profit_price,
        total_sales_price: row.total_price,
        fee_total: fee_total,
        commission_dy: commission_dy,
        commission_sell: commission_sell,
        // delivery_price: delivery_price,
        payment_created_at: moment(row.payment_created_at).format(
          "YYYY.MM.DD HH:mm",
        ),
      };
    });
    // console.log(excelData);
    if (excelData?.length) {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "정산내역");
      XLSX.writeFile(wb, `${moment().format("YYYYMM")}_정산내역.xlsx`);
    }
  };

  return (
    <>
      <Row
        className="product-register-border-box"
        justify={"space-between"}
        wrap={false}
        style={{ marginTop: 20, borderBottom: 0 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="product-register-box-title">정산내역 및 목록</span>
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#117ffa" }}>
            구매확정(배송완료일로부터 7일 후)을 기준으로 정산기준일 +1영업일째
            되는 날 정산 된 내역만 표기되어 매출액과 상이할 수 있습니다.
          </p>
        </div>
      </Row>
      <div
        className="product-register-border-box"
        wrap={false}
        style={{ padding: "20px 25px 40px", height: "fit-content" }}
      >
        <div className={`commission-year-select`}>
          <p>정산년도</p>
          <Select
            value={targetYear}
            onChange={(value, option) => {
              setTargetYear(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 년도"}
          >
            {["2022", "2023", "2024"]?.map((item) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
          <Select
            value={targetMonth}
            onChange={(value, option) => {
              handleMonth(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 월도"}
          >
            {Array.from({ length: 12 })?.map((item, idx) => (
              <Option
                key={`year ${idx + 1}`}
                value={idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              >
                {idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              </Option>
            ))}
          </Select>
          <Button
            className="order-excel-download-btn"
            icon={
              <img
                style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                alt={`엑셀이미지`}
              />
            }
            style={{
              marginLeft: "auto",
            }}
            onClick={handleExcelDownloadClick}
          >
            엑셀다운
          </Button>
        </div>

        <div className={`commission-notice-div`}>
          {noticeList?.map((item, idx) => (
            <div
              className={`commission-notice-each`}
              key={`commission-notice-each-${idx}-brand`}
            >
              <p className={`title`}>{item.title}</p>
              <p className={`data`}>
                {idx > 0 ? item.data?.toLocaleString() + "원" : item.data}
              </p>
            </div>
          ))}
        </div>
        <Table
          className={`commission-table`}
          // rowSelection={rowSelection}
          columns={columns}
          dataSource={brandOrderList}
          loading={isLoading}
          bordered
          size="small"
          rowKey="order_detail_id"
          rowClassName="coupon-table-row"
          // scroll={{x: 'calc(700px + 50%)'}}
          // onChange={tableOnChange}
          pagination={false}
        />

        {/*<div style={{textAlign: 'right'}}>*/}
        {/*    <Pagination*/}
        {/*        showQuickJumper*/}
        {/*        showSizeChanger*/}
        {/*        // onShowSizeChange={pageSizeChange}*/}
        {/*        // total={totalSize}*/}
        {/*        // onChange={handleChangePagination}*/}
        {/*        style={{marginTop: 20}}*/}
        {/*        // current={currentPageNumber}*/}
        {/*    />*/}
        {/*</div>*/}
      </div>
    </>
  );
};
export default BrandCase;
